import {MeasurementUnit} from "../MeasurementUnit/MeasurementUnit";
import {Manufacturer} from "../Manufacturer/Manufacturer";
import {validateNumber} from "@musicdata/common/src/Numbers/Validation";
import {validateString} from "@musicdata/common/src/Strings/Validation";

export class Product {

    private _inShopId : number;
    private _inShopCartId : number;
    private _catalogueNumber : string;
    private _name : string;
    public manufacturer : Manufacturer;
    private _availableAmount : number;
    private _minimumSaleAmount : number;
    private _pieceAmount : number;
    public measurementUnit : MeasurementUnit;
    public singList : Array<ESign>;

    public constructor() {
        this._inShopId = null;
        this._inShopCartId = null;
        this._catalogueNumber = null;
        this._name = null;
        this.manufacturer = null;
        this._availableAmount = null;
        this._minimumSaleAmount = null;
        this._pieceAmount = null;
        this.measurementUnit = null;
        this.singList = [];
    }

    public get inShopId() : number {return this._inShopId}
    public set inShopId(inShopId : number) {this._inShopId = validateNumber(inShopId)}

    public get inShopCartId() : number {return this._inShopCartId}
    public set inShopCartId(inShopCartId : number) {this._inShopCartId = validateNumber(inShopCartId)}

    public get catalogueNumber() : string {return this._catalogueNumber}
    public set catalogueNumber(catalogueNumber : string) {this._catalogueNumber = validateString(catalogueNumber)}

    public get name() : string {return this._name}
    public set name(name : string) {this._name = validateString(name)}

    public get availableAmount() : number {return this._availableAmount}
    public set availableAmount(availableAmount : number) {this._availableAmount = validateNumber(availableAmount)}

    public get minimumSaleAmount() : number {return this._minimumSaleAmount}
    public set minimumSaleAmount(minimumSaleAmount : number) {this._minimumSaleAmount = validateNumber(minimumSaleAmount)}

    public get maximumSaleAmount() : number {

        if (this.singList.includes(ESign.sale) || this.singList.includes(ESign.unpacked)) {
            return this.availableAmount;
        }

        return Infinity;
    }

    public get pieceAmount() : number {return this._pieceAmount}
    public set pieceAmount(pieceAmount : number) {this._pieceAmount = validateNumber(pieceAmount)}
}

export enum ESign {
    new,
    tip,
    action,
    sale,
    unpacked,
    productionTerminated,
    showPrice,
}

